// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2020-11-13 21:08:58 +0100 (Fri, 13 Nov 2020) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 114813 $
//  Purpose   : stats views and components
// =============================================================================
export const templates = true
export const parts = true
export const dashpanels = true

import * as views from './views'
export {views}

export const selectors = {
  statistics: root => root.data.stats?.[root.meta.request.dname],
}
